type AsyncError = null | any;

export async function promise2ErrorFirst<T>(promise: Promise<T>): Promise<[AsyncError, T]> {
  try {
    const res = await promise;
    return [null, res];
  } catch (err) {
    return [err, null];
  }
}

// eslint-disable-next-line
export function errFirst<T extends (...args: any[]) => any>(func: T) {
  return function (...args: Parameters<T>) {
    try {
      return promise2ErrorFirst(func(...args) as Promise<Awaited<ReturnType<T>>>);
    } catch (err) {
      return promise2ErrorFirst(Promise.reject(err));
    }
  }
}

export function race<T>(promise: Promise<T>, time = 500) {
  return Promise.race([
    new Promise((resolve, reject) => setTimeout(reject, time)),
    promise
  ])
}
